import AllContactsRoute from "./modules/AllContacts";
import AgentContactsRoute from "./modules/AgentContacts";


export const AllContacts = AllContactsRoute
export const AgentContacts = AgentContactsRoute